var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIconWithGreyBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.0234,
    r: 15,
    fill: "#ECF1F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1962_156753)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6858 9.35489C21.6759 9.22577 21.6215 9.09944 21.5227 9.00069C21.3616 8.83956 21.127 8.79662 20.9268 8.87188L9.68918 12.805C9.47149 12.8812 9.32237 13.0826 9.31297 13.313C9.30357 13.5435 9.43579 13.7563 9.64655 13.85L14.5114 16.0121L16.6735 20.8769C16.7672 21.0877 16.98 21.2199 17.2104 21.2105C17.4409 21.2011 17.6422 21.052 17.7184 20.8343L21.6519 9.59563C21.6808 9.5184 21.6921 9.43609 21.6858 9.35489ZM18.9843 10.7437L11.4 13.3982L14.8129 14.915L18.9843 10.7437ZM15.6084 15.7105L19.7798 11.5391L17.1253 19.1235L15.6084 15.7105Z",
    fill: "#3E556D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1962_156753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(8.75 8.27344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconWithGreyBg);
export default __webpack_public_path__ + "static/media/SendIconWithGreyBg.4e33dc84f6cd47b30c8dd00d1c3792eb.svg";
export { ForwardRef as ReactComponent };